import React from 'react';
import { ReactComponent as LogoSVG } from './sign-white.svg';

export default function LogoSignWhite() {
  return <LogoSVG />;
}
